import React, { useState, useEffect, useRef, useMemo } from "react";
import { Box, BreadcrumbGroup, Button, Container, ExpandableSection, Grid, Icon, Input, SpaceBetween, Spinner, StatusIndicator } from "@amzn/awsui-components-react";
import aiInsights from '../../../images/aiInsights.svg'
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { convertToLocalTime } from "src/Ateam-BI/CorpReporting/Utility";
import { getResultContent } from "../Utility";
import ReactMarkdownRenderer from "./ReactMarkdownRenderer";


const FirstPassResultComponent = (props) => {
  const [viewResultsRequestDetails, setViewResultsRequestDetails] = useState(null)
  const [isResultsLoading, setIsResultsLoading] = useState(false);


  useEffect(() => {
    if (props?.data) {
      loadView()
    }

  }, [props]);

  const loadView = () => {
    fetchDetails(props.data)
  }

  const fetchDetails = async (data) => {
    setIsResultsLoading(true)
    let htmlData = await getResultContent(data)
    data['markdownData'] = htmlData?.markdown
    data['resultObject'] = htmlData?.resultObject
    setViewResultsRequestDetails(data)
    setIsResultsLoading(false)
  }



  return (
    <SpaceBetween direction="vertical" size="m">
      {
        isResultsLoading && <StatusIndicator type="loading">
          Loading
        </StatusIndicator>
      }

      {
        !isResultsLoading && viewResultsRequestDetails && <SpaceBetween direction="vertical" size="l">

          <SpaceBetween direction="horizontal" size="m">
            <img
              className="ai-button"
              src={aiInsights}
              alt=""
            />
            <Box variant="awsui-key-label"> You are viewing results for Entity Name: {viewResultsRequestDetails?.entity_name || '-'}, Execution Date: {convertToLocalTime(viewResultsRequestDetails?.created_at, true) || '-'}, Current year: {viewResultsRequestDetails?.current_year || '-'}, Prior Year: {viewResultsRequestDetails?.previous_year || '-'} </Box>
          </SpaceBetween>

          <SpaceBetween direction="vertical" size="m">

            {
              viewResultsRequestDetails?.resultObject?.length ?
                viewResultsRequestDetails?.resultObject?.map((item, i) => {
                  if (item.group) {
                    return <ExpandableSection
                      defaultExpanded
                      headerText={item.header}
                    >
                      <SpaceBetween direction="vertical" size="l">
                        {
                          item.childContent?.map((child, j) => {
                            return <ExpandableSection
                              defaultExpanded
                              variant="container"
                              headerText={child.header}
                            ><ReactMarkdownRenderer content={child.content}></ReactMarkdownRenderer> </ExpandableSection>
                          })
                        }
                      </SpaceBetween>
                    </ExpandableSection>


                  } else {
                    return <ExpandableSection
                      defaultExpanded
                      variant="container"
                      headerText={item.header}
                    >
                      <ReactMarkdownRenderer content={item.content} ></ReactMarkdownRenderer>
                    </ExpandableSection>


                  }
                })
                :
                <Box color="text-secondary" variant="p">
                  No Data Found
                </Box>

            }

          </SpaceBetween>

        </SpaceBetween>
      }
    </SpaceBetween>

  );
};

export default FirstPassResultComponent;
